import React from 'react';
export function QuickWinSection() {
  return <section className="py-10 bg-main" data-id="element-193">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="text-center mb-10" data-id="element-195">
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-4" data-id="element-196">
            Tu primera semana (sin agobio)
          </h2>
          <p className="text-lg text-body" data-id="element-197">
            No necesitas hacerlo perfecto. Necesitas hacerlo en orden.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6" data-id="element-198">
          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-199">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-200">
              Día 1
            </span>
            <h3 className="font-serif text-lg text-title" data-id="element-201">Ángulo + estética</h3>
          </div>

          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-202">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-203">
              Día 2
            </span>
            <h3 className="font-serif text-lg text-title" data-id="element-204">
              Perfil + bio + estructura
            </h3>
          </div>

          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-205">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-206">
              Día 3
            </span>
            <h3 className="font-serif text-lg text-title" data-id="element-207">
              10 ideas faceless listas
            </h3>
          </div>

          <div className="bg-card p-6 border-t-4 border-accent shadow-sm" data-id="element-208">
            <span className="text-xs font-bold tracking-widest text-accent uppercase mb-2 block" data-id="element-209">
              Día 4-7
            </span>
            <h3 className="font-serif text-lg text-title" data-id="element-210">
              Publicar + ajustar sin exposición
            </h3>
          </div>
        </div>

        <div className="mt-10 text-center" data-id="element-211">
          <p className="inline-block px-6 py-3 bg-alt text-title font-medium tracking-wide border border-[#D9D0C1]" data-id="element-212">
            Menos improvisación. Más claridad.
          </p>
        </div>
      </div>
    </section>;
}